import { render, staticRenderFns } from "./StoreProductGallery.vue?vue&type=template&id=2c001cd8&"
import script from "./StoreProductGallery.vue?vue&type=script&lang=js&"
export * from "./StoreProductGallery.vue?vue&type=script&lang=js&"
import style0 from "./StoreProductGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports